import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { LuMouse } from "react-icons/lu";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css";
import { useSelector } from "react-redux";
import { URL } from "../../api";

const Slider = ({ data }) => {
  const lang = useSelector((state) => state.lang.lang);
  const scrollDown = () => { window.scrollBy({ top: window.innerHeight - (window.innerHeight * 0.08), behavior: "smooth" }); };
  var width = window.innerWidth;

  return (
    <div className="main-bg h100" style={{ position: "relative" }}>
      <Swiper
        slidesPerView={1}
        loop={true}
        modules={[Pagination, Navigation, Autoplay]}
        pagination={{ clickable: true }}
        navigation
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        className="h100x"
      >
        {
          data?.modules?.map((item, index) => {
            return (
              <SwiperSlide className="h100x" key={index}>
                <div className="web-swiper h100x" style={{ position: "relative" }}>
                  <img src={`${URL}${width < 600 ? item?.files[1] || item?.files[0] : item?.files[0]}`} alt="" className="bg h100x" style={{ objectFit: "cover", width: "100%" }} loading="lazy" />
                  <div><div className="swiper-text" dangerouslySetInnerHTML={{ __html: item?.content[lang] }}></div></div>
                </div>
              </SwiperSlide>
            )
          })
        }
        <div className="scroll-down" onClick={scrollDown}>
          <LuMouse size={20} style={{ borderRadius: "2px" }} />
          <span>{data?.specialField1[lang]}</span>
        </div>
      </Swiper>
    </div>
  );
};

export default Slider;
